module.exports = __webpack_public_path__ + "img/imagen-datos-bancarios.bf4422bc.png";